import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import MaterialTable, { MaterialTableProps, Localization } from 'material-table'
import { AddBox } from '@material-ui/icons';
import { Button } from '@material-ui/core';

import { defaultMaterialTableIcons } from './material-table-icons'

interface OwnProps {
  data?: Array<any>;
  addItemLabel?: string; // We want to make the add item button more prominent
}

type Props = OwnProps & Omit<MaterialTableProps<any>, 'data'>

type L10n = Localization | undefined;

export const Table = ({ addItemLabel, data, columns, options, ...tableProps }: Props) => {
  const { t, i18n } = useTranslation()
  const defaultOptions = {
    actionsColumnIndex: columns.length,
  }
  const getLocatization: () => L10n = () => {
    if (i18n.language !== 'en_US') {
      return t('table', { returnObjects: true })
    }
    return undefined;
  }
  const tableOptions = { ...defaultOptions, ...options }
  let tableIcons = defaultMaterialTableIcons;
  if (!!addItemLabel) {
    tableIcons = {
      ...defaultMaterialTableIcons,
      Add: forwardRef(() => (
        <Button
          variant='contained'
          color='primary'
          startIcon={<AddBox />}
        >
          {addItemLabel}
        </Button>
      ))
    }
  }
  return(
    <MaterialTable
      data={data || []}
      columns={columns}
      icons={tableIcons}
      localization={getLocatization()}
      options={tableOptions}
      {...tableProps}
    />
  )
}
